import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Card,
	CardBody,
	FormGroup,
	Label,
	Input,
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from 'reactstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import { NotificationManager } from 'Components/ReactNotifications';
import LoadingOverlay from 'Components/LoadingOverlay';
import CustomSelectInput from 'Components/CustomSelectInput';
import IntlMessages from 'Util/IntlMessages';
import {
	couponsCreate,
	couponsGetDetails,
	couponsUpdate,
	couponsReset,
	couponsCopy,
	couponsGetOptions,
	errorReset,
} from 'Redux/actions';
import * as couponsReducer from 'Redux/coupons/reducer';

import 'react-datepicker/dist/react-datepicker.css';
import 'Assets/css/vendor/react-datepicker.css';

const STATUS_OPTIONS = [
	{ value: 'C', label: 'C - Cancelled' },
	{ value: 'M', label: 'M - Modified' },
	{ value: 'N', label: 'N - New' },
	{ value: 'R', label: 'R - Redeemed' },
];

const DISCOUNT_TYPE_OPTIONS = [
	{ value: '1', label: '% (Percentage)' },
	{ value: '2', label: 'Amount' },
];

class PageCoupon extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			brNo: '',
			brStatus: { value: 'N', label: 'N - New' },
			brDate: null,
			expiryDate: moment().endOf('day'),
			couponAmt: 0,
			discountType: null,
			statementDesc: '',
			requireSale: 'N',
			cashCoupon: 'N',
			itemDisplay: 'COUPON',
			saleDisplay: '',
			usedOnce: 'N',
			bonusType: null,
			altC3: '',
			remark: '',
			isCopyModalOpen: false,
			copyMode: 'duplicate',
			newBrNo: '',
			rangeFrom: '',
			rangeTo: '',
			rangeFormat: '',
			copyResultText: '',
			fieldErrors: {},
		};
		this.getBrNo = this.getBrNo.bind(this);
		this.getBreadcrumb = this.getBreadcrumb.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
		this.onResetHandler = this.onResetHandler.bind(this);
		this.onOpenCopyModal = this.onOpenCopyModal.bind(this);
		this.onCloseCopyModal = this.onCloseCopyModal.bind(this);
		this.onConfirmCopyHandler = this.onConfirmCopyHandler.bind(this);
		this.formatCopyErrorText = this.formatCopyErrorText.bind(this);
	}

	getBrNo(props = this.props) {
		return props.match.params.couponId ? decodeURIComponent(props.match.params.couponId) : null;
	}

	getBreadcrumb(props = this.props) {
		const brNo = this.getBrNo(props);
		return [
			{ id: 'menu.coupon', href: '/coupon/list' },
			{ id: 'coupon.heading', href: brNo ? `/coupon/edit/${encodeURIComponent(brNo)}` : '/coupon/create' },
		];
	}

	componentDidMount() {
		const brNo = this.getBrNo();
		if (brNo) {
			this.props.couponsGetDetails(brNo);
		}
		this.props.couponsGetOptions();
		this.props.errorReset('coupon');
	}

	componentDidUpdate(prevProps) {
		const brNo = this.getBrNo();
		const prevBrNo = this.getBrNo(prevProps);

		if (brNo) {
			const prevCoupon = prevProps.coupon.get(brNo);
			const coupon = this.props.coupon.get(brNo);
			if ((prevBrNo !== brNo || (coupon && coupon !== prevCoupon)) && coupon) {
				const couponType = coupon.coupon_type || 'G';
				const requireSale = couponType === 'S' ? 'Y' : 'N';
				const cashCoupon = (couponType === 'S' || couponType === 'C') ? 'Y' : 'N';
				this.setState({
					brNo: coupon.br_no || '',
					brStatus: STATUS_OPTIONS.find((o) => o.value === coupon.br_status) || null,
					brDate: coupon.br_date ? moment(coupon.br_date) : null,
					expiryDate: coupon.expiry_date ? moment(coupon.expiry_date) : null,
					couponAmt: coupon.coupon_amt !== null && coupon.coupon_amt !== undefined ? String(coupon.coupon_amt) : 0,
					discountType: DISCOUNT_TYPE_OPTIONS.find((o) => o.value === coupon.discount_type) || null,
					statementDesc: coupon.statement_desc || '',
					requireSale,
					cashCoupon,
					itemDisplay: coupon.gift_code || '',
					saleDisplay: coupon.item_code || '',
					usedOnce: coupon.used_once || null,
					bonusType: coupon.bonus_type ? { value: coupon.bonus_type, label: coupon.bonus_type_description ? `${coupon.bonus_type} - ${coupon.bonus_type_description}` : coupon.bonus_type } : null,
					altC3: coupon.alt_c3 || '',
					remark: coupon.remark || '',
				});
			}
		}

		const prevStatus = prevProps.status.get('coupon');
		const status = this.props.status.get('coupon');
		const current = this.props.current;
		const copyResult = this.props.copyResult;
		const currentBrNo = (this.state.brNo || '').trim();

		if (status && prevStatus !== status) {
			switch (status) {
			case 'created':
				NotificationManager.success('The coupon is created successfully.', 'Coupon Created');
				if (current || currentBrNo) {
					this.props.history.push(`/app/coupon/edit/${encodeURIComponent(current || currentBrNo)}`);
				}
				break;
			case 'submitted':
				NotificationManager.success('The coupon is updated successfully.', 'Coupon Updated');
				if (brNo) {
					this.props.couponsGetDetails(brNo);
				}
				break;
			case 'reset':
				NotificationManager.success('The coupon is reset successfully.', 'Coupon Reset');
				if (brNo) {
					this.props.couponsGetDetails(brNo);
				}
				break;
			case 'copied':
				if (copyResult && copyResult.mode === 'range') {
					const createdCount = copyResult.created_count || 0;
					const firstBrNo = copyResult.first_br_no || '—';
					const lastBrNo = copyResult.last_br_no || '—';
					this.setState({
						copyResultText: `Range copy completed successfully.\nCreated: ${createdCount}\nFirst Coupon No.: ${firstBrNo}\nLast Coupon No.: ${lastBrNo}`,
					});
				} else {
					const copiedBrNo = current || (copyResult && copyResult.br_no) || '';
					this.setState({
						copyResultText: copiedBrNo
							? `Duplicate copy completed successfully.\nNew Coupon No.: ${copiedBrNo}`
							: 'Duplicate copy completed successfully.',
					});
				}
				break;
			case 'has-errors':
				if (prevStatus === 'copying') {
					this.setState({ copyResultText: this.formatCopyErrorText() });
				} else {
					const { errors } = this.props;
					let fieldErrors = {};
					let errorMessage = 'An error occurred. The operation failed.';
					if (errors && errors.message) {
						errorMessage = errors.message;
					}
					if (errors && errors.detail && typeof errors.detail === 'object') {
						fieldErrors = errors.detail;
					}
					this.setState({ fieldErrors });
					NotificationManager.error(errorMessage, 'Operation Failed', 10000);
				}
				break;
			default:
				break;
			}
		}
	}

	formatCopyErrorText() {
		const { errors } = this.props;
		if (!errors) {
			return 'Copy failed.';
		}

		const lines = [];
		if (errors.message) {
			lines.push(errors.message);
		}

		const detail = errors.detail;
		if (detail) {
			if (Array.isArray(detail)) {
				lines.push(...detail.map((item) => String(item)));
			} else if (typeof detail === 'string') {
				lines.push(detail);
			} else if (typeof detail === 'object') {
				Object.keys(detail).forEach((key) => {
					const value = detail[key];
					if (key === 'existing_br_no' && Array.isArray(value) && value.length > 0) {
						lines[0] = 'Copy failed because some coupon numbers already exist.'; // Override the main message
						lines.push(...value.map((couponNo) => `- ${couponNo}`));
						return;
					}
					if (Array.isArray(value)) {
						lines.push(`${key}: ${value.join(', ')}`);
					} else if (value && typeof value === 'object') {
						lines.push(`${key}: ${JSON.stringify(value)}`);
					} else if (value !== undefined && value !== null) {
						lines.push(`${key}: ${value}`);
					}
				});
			}
		}

		return lines.length > 0 ? lines.join('\n') : 'Copy failed.';
	}

	renderFieldError(fieldKey) {
		const { fieldErrors } = this.state;
		if (!fieldErrors || !fieldErrors[fieldKey]) {
			return null;
		}
		const errors = fieldErrors[fieldKey];
		const message = Array.isArray(errors) ? errors.join(', ') : errors;
		return <div className="text-danger small mt-1">{message}</div>;
	}

	onChangeHandler(field, value) {
		const fieldErrorMap = {
			brNo: 'br_no',
			brDate: 'br_date',
			expiryDate: 'expiry_date',
			couponAmt: 'coupon_amt',
			discountType: 'discount_type',
			statementDesc: 'statement_desc',
			cashCoupon: 'coupon_type',
			requireSale: 'coupon_type',
			bonusType: 'bonus_type',
			altC3: 'alt_c3',
			remark: 'remark',
		};
		const errorKey = fieldErrorMap[field];
		if (field === 'brNo') {
			const update = { brNo: value.toUpperCase() };
			if (errorKey && this.state.fieldErrors[errorKey]) {
				const fieldErrors = { ...this.state.fieldErrors };
				delete fieldErrors[errorKey];
				update.fieldErrors = fieldErrors;
			}
			this.setState(update);
			return;
		}
		if (field === 'brDate' || field === 'expiryDate') {
			if (value && value._isAMomentObject) {
				if (value.minute() === 59) {
					value.second(59);
				} else {
					value.second(0);
				}
			}
		}
		const update = { [field]: value };
		if (errorKey && this.state.fieldErrors[errorKey]) {
			const fieldErrors = { ...this.state.fieldErrors };
			delete fieldErrors[errorKey];
			update.fieldErrors = fieldErrors;
		}
		if (field === 'cashCoupon' && value === 'N') {
			update.bonusType = null;
		}
		this.setState(update);
	}

	onSubmitHandler(e) {
		e && e.preventDefault();
		const brNo = this.getBrNo();
		const {
			brNo: couponNo,
			brStatus,
			brDate,
			expiryDate,
			couponAmt,
			discountType,
			statementDesc,
			requireSale,
			cashCoupon,
			itemDisplay,
			saleDisplay,
			usedOnce,
			bonusType,
			altC3,
			remark,
		} = this.state;
		const isCreate = !brNo;
		const couponNumber = isCreate ? couponNo.trim() : brNo;
		if (isCreate && !couponNumber) {
			return;
		}

		const couponType = requireSale === 'Y' ? 'S' : (cashCoupon === 'Y' ? 'C' : 'G');
		const payload = {
			br_no: couponNumber,
			br_status: brStatus ? brStatus.value : null,
			br_date: brDate ? moment(brDate).format('YYYY-MM-DD HH:mm:ss') : null,
			expiry_date: expiryDate ? moment(expiryDate).format('YYYY-MM-DD HH:mm:ss') : null,
			coupon_amt: couponAmt !== '' ? couponAmt : 0,
			discount_type: discountType ? discountType.value : null,
			statement_desc: statementDesc || null,
			coupon_type: couponType || null,
			gift_code: itemDisplay || null,
			item_code: saleDisplay || null,
			used_once: usedOnce || null,
			bonus_type: bonusType ? bonusType.value : null,
			alt_c3: altC3 || null,
			remark: remark || null,
		};

		if (isCreate) {
			this.props.couponsCreate(payload);
		} else {
			this.props.couponsUpdate(payload);
		}
	}

	onResetHandler() {
		const brNo = this.getBrNo();
		if (!window.confirm('Are you sure you want to reset this coupon? Status will be set to "N" and redeem info will be cleared.')) {
			return;
		}
		this.props.couponsReset({ br_no: brNo });
	}

	onOpenCopyModal() {
		this.setState({
			isCopyModalOpen: true,
			copyMode: 'duplicate',
			newBrNo: '',
			rangeFrom: '',
			rangeTo: '',
			rangeFormat: '',
			copyResultText: '',
		});
	}

	onCloseCopyModal() {
		this.setState({
			isCopyModalOpen: false,
			copyMode: 'duplicate',
			newBrNo: '',
			rangeFrom: '',
			rangeTo: '',
			rangeFormat: '',
			copyResultText: '',
		});
	}

	getCopyValidationError() {
		const {
			copyMode,
			newBrNo,
			rangeFrom,
			rangeTo,
			rangeFormat,
		} = this.state;

		if (copyMode === 'duplicate') {
			if (!newBrNo.trim()) {
				return 'New Coupon No. is required.';
			}
			return null;
		}

		if (!rangeFrom.trim() || !rangeTo.trim() || !rangeFormat.trim()) {
			return 'Range from, range to and format are required.';
		}

		if (!/^\d+$/.test(rangeFrom.trim()) || !/^\d+$/.test(rangeTo.trim())) {
			return 'Range from and range to must be numeric values.';
		}

		const from = parseInt(rangeFrom.trim(), 10);
		const to = parseInt(rangeTo.trim(), 10);
		if (from > to) {
			return 'Range end must be greater than or equal to range start.';
		}

		const count = (to - from) + 1;
		if (count > 2000) {
			return 'Range size cannot exceed 2000.';
		}

		const matches = rangeFormat.trim().match(/#+/g) || [];
		if (matches.length !== 1) {
			return 'Format must contain exactly one placeholder block of #.';
		}

		const width = matches[0].length;
		if (String(from).length > width || String(to).length > width) {
			return 'Range value exceeds format placeholder width.';
		}

		return null;
	}

	onConfirmCopyHandler() {
		const brNo = this.getBrNo();
		const {
			copyMode,
			newBrNo,
			rangeFrom,
			rangeTo,
			rangeFormat,
		} = this.state;

		const copyValidationError = this.getCopyValidationError();
		if (copyValidationError) {
			return;
		}

		if (copyMode === 'range') {
			this.setState({ copyResultText: '' });
			this.props.couponsCopy({
				mode: 'range',
				source_br_no: brNo,
				range_from: parseInt(rangeFrom.trim(), 10),
				range_to: parseInt(rangeTo.trim(), 10),
				format: rangeFormat.trim().toUpperCase(),
			});
			return;
		}

		this.setState({ copyResultText: '' });
		this.props.couponsCopy({
			mode: 'duplicate',
			source_br_no: brNo,
			new_br_no: newBrNo.trim().toUpperCase(),
		});
	}

	render() {
		const brNo = this.getBrNo();
		const coupon = brNo ? this.props.coupon.get(brNo) : null;
		const isCreate = !brNo;
		const { options } = this.props;
		const couponStatus = this.props.status.get('coupon');
		const isLoading = couponStatus === 'fetching';
		const isSubmitting = couponStatus === 'submitting' || couponStatus === 'resetting' || couponStatus === 'copying';

		const {
			brStatus,
			brDate,
			expiryDate,
			couponAmt,
			discountType,
			statementDesc,
			requireSale,
			cashCoupon,
			itemDisplay,
			saleDisplay,
			usedOnce,
			bonusType,
			altC3,
			remark,
			isCopyModalOpen,
			copyMode,
			newBrNo,
			rangeFrom,
			rangeTo,
			rangeFormat,
			copyResultText,
		} = this.state;
		const copyValidationError = this.getCopyValidationError();

		const categoryOptions = options.get('coupon_category') ? options.get('coupon_category') : [];
		const selectedCategory = bonusType && bonusType.value ? bonusType.value : null;
		const applicableWarehouses = selectedCategory && Array.isArray(categoryOptions)
			? (((categoryOptions.find((category) => category.value === selectedCategory) || {}).shops || []).slice().sort((a, b) => {
				const codeA = (a.sh_code || '').trim();
				const codeB = (b.sh_code || '').trim();
				return codeA.localeCompare(codeB);
			}))
			: [];

		return (
			<Fragment>
				<LoadingOverlay active={isLoading} />
				<Row>
					<Colxx xxs="12">
						<div className="float-left">
							<BreadcrumbContainer
								heading={<IntlMessages id="coupon.heading" />}
								items={this.getBreadcrumb()}
								match={this.props.match}
							/>
						</div>
						{brNo && (
							<div className="float-right">
								<Button
									color="warning"
									className="mr-2"
									onClick={this.onOpenCopyModal}
									disabled={isSubmitting}
								>
									Copy Coupon
								</Button>
								<Button
									color="danger"
									onClick={this.onResetHandler}
									disabled={isSubmitting}
								>
									Reset Coupon
								</Button>
							</div>
						)}
						<div className="clearfix"></div>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<Row>
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<form onSubmit={this.onSubmitHandler}>
									<Row>
										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Coupon No.</Label>
												{isCreate ? (
													<Input
														type="text"
														value={this.state.brNo}
														maxLength={15}
														onChange={(e) => this.onChangeHandler('brNo', e.target.value)}
														placeholder="Enter coupon number"
													/>
												) : (
													<Input
														type="text"
														value={brNo || ''}
														readOnly
														disabled
													/>
												)}
												{this.renderFieldError('br_no')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Status</Label>
												<Select
													components={{ Input: CustomSelectInput }}
													className="react-select"
													classNamePrefix="react-select"
													value={brStatus}
													onChange={(v) => this.onChangeHandler('brStatus', v)}
													options={STATUS_OPTIONS}
												/>
											</FormGroup>
										</Colxx>

										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Effective Date</Label>
												<DatePicker
													selected={brDate}
													selectsStart
													startDate={brDate}
													endDate={expiryDate}
													onChange={(date) => this.onChangeHandler('brDate', date)}
													showTimeSelect
													timeFormat="HH:mm:ss"
													timeCaption="Time"
													timeIntervals={1}
													dateFormat="YYYY-MM-DD HH:mm:ss"
													placeholderText="Effective Date"
													className="form-control"
												/>
												{this.renderFieldError('br_date')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Expiry Date</Label>
												<DatePicker
													selected={expiryDate}
													selectsEnd
													startDate={brDate}
													endDate={expiryDate}
													onChange={(date) => this.onChangeHandler('expiryDate', date)}
													showTimeSelect
													timeFormat="HH:mm:ss"
													timeIntervals={1}
													timeCaption="Time"
													dateFormat="YYYY-MM-DD HH:mm:ss"
													placeholderText="Expiry Date"
													className="form-control"
												/>
												{this.renderFieldError('expiry_date')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Discount Amount</Label>
												<Input
													type="number"
													step="1"
													value={parseInt(couponAmt) || 0}
													onChange={(e) => this.onChangeHandler('couponAmt', parseInt(e.target.value))}
												/>
												{this.renderFieldError('coupon_amt')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Amount / %</Label>
												<Select
													components={{ Input: CustomSelectInput }}
													className="react-select"
													classNamePrefix="react-select"
													value={discountType}
													onChange={(v) => this.onChangeHandler('discountType', v)}
													options={DISCOUNT_TYPE_OPTIONS}
												/>
												{this.renderFieldError('discount_type')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12">
											<FormGroup>
												<Label>Coupon Description</Label>
												<Input
													type="textarea"
													rows={3}
													value={statementDesc}
													onChange={(e) => this.onChangeHandler('statementDesc', e.target.value)}
												/>
												{this.renderFieldError('statement_desc')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12" md="6">
											<Row>
												<Colxx xxs="12" md="4">
													<Label className="mb-0">Cash Coupon</Label>
												</Colxx>
												<Colxx xxs="12" md="4">
													<Input
														type="radio"
														name="couponType"
														id="couponTypeYes"
														value="Y"
														checked={cashCoupon === 'Y'}
														onChange={() => this.onChangeHandler('cashCoupon', 'Y')}
													/>
													{' '}
													<Label for="couponTypeYes">Yes</Label>
												</Colxx>
												<Colxx xxs="12" md="4">
													<Input
														type="radio"
														name="couponType"
														id="couponTypeNo"
														value="N"
														checked={cashCoupon === 'N'}
														onChange={() => this.onChangeHandler('cashCoupon', 'N')}
													/>
													{' '}
													<Label for="couponTypeNo">No</Label>
												</Colxx>
											</Row>
											{this.renderFieldError('coupon_type')}
											<Row>
												<Colxx xxs="12" md="4">
													<Label className="mb-0">Require Sale</Label>
												</Colxx>
												<Colxx xxs="12" md="4">
													<Input
														type="radio"
														name="requireSale"
														id="requireSaleYes"
														value="Y"
														checked={requireSale === 'Y'}
														onChange={() => this.onChangeHandler('requireSale', 'Y')}
													/>
													{' '}
													<Label for="requireSaleYes">Yes</Label>
												</Colxx>
												<Colxx xxs="12" md="4">
													<Input
														type="radio"
														name="requireSale"
														id="requireSaleNo"
														value="N"
														checked={requireSale === 'N'}
														onChange={() => this.onChangeHandler('requireSale', 'N')}
													/>
													{' '}
													<Label for="requireSaleNo">No</Label>
												</Colxx>
											</Row>
											<Row>
												<Colxx xxs="12" md="4">
													<Label className="mb-0">Only Once</Label>
												</Colxx>
												<Colxx xxs="12" md="4">
													<Input
														type="radio"
														name="usedOnce"
														id="usedOnceYes"
														value="Y"
														checked={usedOnce === 'Y'}
														onChange={() => this.onChangeHandler('usedOnce', 'Y')}
													/>
													{' '}
													<Label for="usedOnceYes">Yes</Label>
												</Colxx>
												<Colxx xxs="12" md="4">
													<Input
														type="radio"
														name="usedOnce"
														id="usedOnceNo"
														value="N"
														checked={usedOnce === 'N'}
														onChange={() => this.onChangeHandler('usedOnce', 'N')}
													/>
													{' '}
													<Label for="usedOnceNo">No</Label>
												</Colxx>
											</Row>

											<Row className="mt-1">
												<Colxx>
													<FormGroup>
														<Label>Apply Shop</Label>
														<Select
															components={{ Input: CustomSelectInput }}
															className="react-select"
															classNamePrefix="react-select"
															value={bonusType}
															isClearable={true}
															isDisabled={cashCoupon !== 'Y'}
															onChange={(v) => this.onChangeHandler('bonusType', v)}
															options={categoryOptions}
														/>
														{this.renderFieldError('bonus_type')}
													</FormGroup>
												</Colxx>
											</Row>
										</Colxx>

										<Colxx xxs="12" md="6">
											<FormGroup>
												<Label>Item Display</Label>
												<Input
													type="text"
													value={itemDisplay}
													disabled={cashCoupon !== 'N'}
													onChange={(e) => this.onChangeHandler('itemDisplay', e.target.value)}
												/>
												{this.renderFieldError('gift_code')}
											</FormGroup>

											<FormGroup>
												<Label>Sale From Item</Label>
												<Input
													type="text"
													value={saleDisplay}
													disabled={requireSale !== 'Y'}
													onChange={(e) => this.onChangeHandler('saleDisplay', e.target.value)}
												/>
												{this.renderFieldError('item_code')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12">
											<FormGroup>
												<Label>Applicable Shops</Label>
												<div>
													{applicableWarehouses.length > 0 ? (
														applicableWarehouses.map((shop, idx) => (
															<span key={`${shop.sh_code || ''}-${idx}`} className="badge badge-secondary mr-1 mb-1">
																{shop.sh_code || '—'}{shop.sh_name ? ` - ${shop.sh_name}` : ''}
															</span>
														))
													) : (
														<span>—</span>
													)}
												</div>
											</FormGroup>
										</Colxx>

										<Colxx xxs="12">
											<FormGroup>
												<Label>Promotion</Label>
												<div>
													{coupon && coupon.promotions && coupon.promotions.length > 0 ? (
														coupon.promotions.map((p) => (
															<a key={p.id} href={`/app/promotion/edit/${p.id}`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-sm mb-1">
																<i className="simple-icon-share-alt mr-2" />
																{p.name}: {p.description}
															</a>
														))
													) : (
														<span>—</span>
													)}
												</div>
											</FormGroup>
										</Colxx>

										<Colxx xxs="12">
											<FormGroup>
												<Label>For Auto-Reactivation (Alt C3)</Label>
												<Input
													type="text"
													value={altC3}
													onChange={(e) => this.onChangeHandler('altC3', e.target.value)}
												/>
												{this.renderFieldError('alt_c3')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12">
											<FormGroup>
												<Label>Remark</Label>
												<Input
													type="textarea"
													rows={3}
													value={remark}
													onChange={(e) => this.onChangeHandler('remark', e.target.value)}
												/>
												{this.renderFieldError('remark')}
											</FormGroup>
										</Colxx>

										<Colxx xxs="12">
											<hr />
											<Row>
												<Colxx xxs="12" md="4">
													<FormGroup>
														<Label>Sale Shop</Label>
														<Input type="text" value={coupon && coupon.sale_shop ? coupon.sale_shop : ''} readOnly disabled />
													</FormGroup>
												</Colxx>
												<Colxx xxs="12" md="4">
													<FormGroup>
														<Label>Sale Date</Label>
														<Input type="text" value={coupon && coupon.sale_date ? moment(coupon.sale_date).format('YYYY-MM-DD HH:mm:ss') : ''} readOnly disabled />
													</FormGroup>
												</Colxx>
												<Colxx xxs="12" md="4" />
											</Row>
											<Row>
												<Colxx xxs="12" md="4">
													<FormGroup>
														<Label>Redeem Shop</Label>
														<Input type="text" value={coupon && coupon.red_shop ? coupon.red_shop : ''} readOnly disabled />
													</FormGroup>
												</Colxx>
												<Colxx xxs="12" md="4">
													<FormGroup>
														<Label>Redeem Date</Label>
														<Input type="text" value={coupon && coupon.red_date ? moment(coupon.red_date).format('YYYY-MM-DD HH:mm:ss') : ''} readOnly disabled />
													</FormGroup>
												</Colxx>
												<Colxx xxs="12" md="4">
													<div className="text-right mt-4">
														<div>Updated On: {coupon && coupon.updated_on ? coupon.updated_on : '—'}</div>
														<div>Updated By: {coupon && coupon.updated_by ? coupon.updated_by : '—'}</div>
													</div>
												</Colxx>
											</Row>
										</Colxx>
									</Row>

									<div className="text-center mt-2">
										<Button
											type="submit"
											size="lg"
											color="primary"
											disabled={isSubmitting}
										>
											{isSubmitting ? 'Saving...' : (isCreate ? 'Create' : 'Save')}
										</Button>
									</div>
								</form>
							</CardBody>
						</Card>
					</Colxx>
				</Row>

				{ /* Copy Coupon Modal */}
				<Modal isOpen={isCopyModalOpen} toggle={this.onCloseCopyModal}>
					<ModalHeader toggle={this.onCloseCopyModal}>Copy Coupon</ModalHeader>
					<ModalBody>
						<FormGroup>
							<div className="form-check mb-2">
								<Input
									type="radio"
									name="copyMode"
									id="copyModeDuplicate"
									checked={copyMode === 'duplicate'}
									onChange={() => this.setState({ copyMode: 'duplicate' })}
								/>
								{' '}
								<Label for="copyModeDuplicate" className="mb-0">
									Duplicate: Enter a new coupon no. to clone all settings from this coupon.
								</Label>
							</div>
							<div className="form-check">
								<Input
									type="radio"
									name="copyMode"
									id="copyModeRange"
									checked={copyMode === 'range'}
									onChange={() => this.setState({ copyMode: 'range' })}
								/>
								{' '}
								<Label for="copyModeRange" className="mb-0">
									Range: Generate coupon numbers from a numeric range using a format template.
								</Label>
							</div>
						</FormGroup>

						{copyMode === 'duplicate' ? (
							<FormGroup>
								<Label>New Coupon No.</Label>
								<Input
									type="text"
									maxLength={15}
									value={newBrNo}
									onChange={(e) => this.setState({ newBrNo: e.target.value.toUpperCase() })}
									placeholder="Enter new coupon number"
								/>
							</FormGroup>
						) : (
							<Fragment>
								<FormGroup>
									<Label>Range from</Label>
									<Input
										type="text"
										value={rangeFrom}
										onChange={(e) => this.setState({ rangeFrom: e.target.value.replace(/\D/g, '') })}
										placeholder="e.g. 1"
									/>
								</FormGroup>
								<FormGroup>
									<Label>Range to</Label>
									<Input
										type="text"
										value={rangeTo}
										onChange={(e) => this.setState({ rangeTo: e.target.value.replace(/\D/g, '') })}
										placeholder="e.g. 100"
									/>
								</FormGroup>
								<FormGroup>
									<Label>Format</Label>
									<Input
										type="text"
										maxLength={15}
										value={rangeFormat}
										onChange={(e) => this.setState({ rangeFormat: e.target.value.toUpperCase() })}
										placeholder="e.g. PG-GT-######"
									/>
									<small className="form-text text-muted">
										Use exactly one # placeholder block. Example: PG-GT-###### with range 1 to 3 generates PG-GT-000001 to PG-GT-000003.
									</small>
								</FormGroup>
							</Fragment>
						)}
						{copyValidationError && (
							<div className="text-danger small">
								{copyValidationError}
							</div>
						)}
						<FormGroup className="mt-3 mb-0">
							<Label>Copy Result</Label>
							<Input
								type="textarea"
								rows={5}
								value={copyResultText}
								readOnly
								placeholder="Copy result will appear here after execution."
							/>
						</FormGroup>
					</ModalBody>
					<ModalFooter>
						<Button
							color="primary"
							onClick={this.onConfirmCopyHandler}
							disabled={!!copyValidationError || isSubmitting}
						>
							Confirm Copy
						</Button>
						<Button color="secondary" onClick={this.onCloseCopyModal}>
							Cancel
						</Button>
					</ModalFooter>
				</Modal>
			</Fragment>
		);
	}
}

export default connect(
	couponsReducer.selector,
	{
		couponsCreate,
		couponsGetDetails,
		couponsUpdate,
		couponsReset,
		couponsCopy,
		couponsGetOptions,
		errorReset,
	}
)(PageCoupon);
